import { isOfType } from '@hsp/utilities';

import { IDataPaging, IResult, IResultPaged } from 'types/api/common';

export const isResult = <TData = unknown>(value: unknown): value is IResult<TData> =>
  isOfType<IResult<TData>>(value, 'dataContainer');

export const isResultPaged = <TData = unknown>(value: unknown): value is IResultPaged<TData> => {
  if (!isResult(value)) {
    return false;
  }

  if (!isOfType<IResultPaged<TData>>(value, 'dataContainer')) {
    return false;
  }

  const { dataContainer } = value;

  return isOfType<IDataPaging>(dataContainer, 'page');
};

export const isPagingData = <TData = unknown>(value: unknown): value is IDataPaging & IResult<TData> => {
  return isOfType<IDataPaging>(value, 'page');
};
